import React, { FC, useRef, useEffect, forwardRef } from 'react';
// @ts-ignore
import Web_WebView from 'react-native-web-webview';
import { Props } from './types';



// export const WebView: FC<Props> = React.forwardRef<Web_WebView, Props>(({  onMessage, ...props }, ref) => {
const AuthWebView: FC<Props> = forwardRef<Web_WebView, Props>(({ token, source: originalSource, ...props }, ref) => {

    const [source, setSource] = React.useState<Props['source'] | null>(null);

    // If a source URI is provided, make a authenticated request to that URI
    useEffect(() => {
        if (!originalSource) return;
        
        let objectURL: string | null = null;

        if ('uri' in originalSource) {
            const uri = originalSource.uri;
            let xhr = new XMLHttpRequest();
            xhr.open('GET', `${uri}`);
            xhr.responseType = 'blob';
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.onreadystatechange = () => {
                if (xhr.response) {
                    objectURL = URL.createObjectURL(xhr.response);
                    setSource({ uri: objectURL });
                }
            };
            xhr.send();
        }
        // Otherwise, just provided the source as is to the web view
        else {
            setSource(originalSource);
        }

        // URL.revokeObjectURL() to avoid memory leaks.
        return () => {
            objectURL ? URL.revokeObjectURL(objectURL) : null;
        }
    }, [token]);

    if (source) {
        return <Web_WebView {...props} source={source} ref={ref} originWhitelist={['*']} />;
    } else {
        return null;
    }
});

export default AuthWebView;